import { useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * useAdminUnlock — reveals the admin entrance after 5 consecutive taps on
 * the GetSpark logo, within a rolling ~3s window.
 *
 * These 5 taps are NOT authentication. They only navigate to /admin/login,
 * where the real authentication happens against Supabase Auth + is_admin flag.
 *
 * Usage:
 *   const onLogoTap = useAdminUnlock();
 *   <button onClick={onLogoTap}> <SparkLogo /> </button>
 */
const REQUIRED_TAPS = 5;
const WINDOW_MS = 3000;

export default function useAdminUnlock() {
  const navigate = useNavigate();
  const timestamps = useRef([]);

  return useCallback(
    (e) => {
      // Don't hijack real navigation from anchor clicks
      if (e && typeof e.preventDefault === 'function') {
        // We allow the event to continue for logo links; the counter
        // is purely additive.
      }
      const now = Date.now();
      // Drop stale taps outside the rolling window
      timestamps.current = [...timestamps.current, now].filter(
        (t) => now - t <= WINDOW_MS
      );

      if (timestamps.current.length >= REQUIRED_TAPS) {
        timestamps.current = [];
        // Use replace:false so user can Back out if they didn't mean to
        navigate('/admin/login');
      }
    },
    [navigate]
  );
}
